// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"; 
const firebaseConfig = {
  apiKey: "AIzaSyBqwZdIaa-7lEfGaZZEQVbtYDLp1YijxZ0",
  authDomain: "frontend-mentor-1234.firebaseapp.com",
  projectId: "frontend-mentor-1234",
  storageBucket: "frontend-mentor-1234.appspot.com",
  messagingSenderId: "32603973864",
  appId: "1:32603973864:web:8a794e6acd0780641a015d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app